import { render, staticRenderFns } from "./OnlineGatewayPayments.vue?vue&type=template&id=607557b4"
import script from "./OnlineGatewayPayments.vue?vue&type=script&lang=js"
export * from "./OnlineGatewayPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports